import envDetect from '@tcc/env-detect';
import { hashHistory } from 'react-router';
import { queryStringToObject } from '../utils/transform';

// @TODO Add this from the Versions.json or Package.json
// For Experiments, this needs to be the same name used in
// @code scripts/exp_deploy.sh
const APP_NAME = 'dmb';

/**
 * Expose the global envDetect values to the app props
 * @return {Promise}
 */
export default function setup() {
  return Promise.resolve({env: {
    name: APP_NAME,
    rootUrl: `https://${envDetect.getEnvHostname(envDetect.getCurrentEnv())}`,
    apiUrl: envDetect.getServiceHostname(),
    href: window.location.href,
    env: envDetect.getCurrentEnv(),
    queryParams: queryStringToObject(hashHistory.getCurrentLocation().search),
  }});
}

/**
 * Expose current NODE_ENV to the rest of the application
 * for better detecting testing, production, etc environments.
 * Exported into global scope from webpack's definePlugin.
 * @constant
 * @type {string}
 */
/* eslint-disable-next-line no-process-env */
export const {NODE_ENV} = process.env;
